import type { RatePlanMatchRequest } from './ratePlanMatchPrompt';

/** Request key -> the rate plan name the AI was confident in, or null when it wasn't. */
export type RatePlanAnswers = Record<string, string | null>;

// Everything the AI is asked about a package, so an answer is reused only for an identical question.
export function getRatePlanRequestKey({ packageId, packageName, ratePlanNames, roomName }: RatePlanMatchRequest) {
  return JSON.stringify([packageId, packageName, roomName ?? null, [...ratePlanNames].sort()]);
}

export function getUnansweredRequests(requests: Array<RatePlanMatchRequest>, answers: RatePlanAnswers) {
  return requests.filter((request) => !(getRatePlanRequestKey(request) in answers));
}

export function recordRatePlanAnswers(
  answers: RatePlanAnswers,
  askedRequests: Array<RatePlanMatchRequest>,
  matchedRatePlanNameByPackageId: Record<string, string>,
): RatePlanAnswers {
  return {
    ...answers,
    ...Object.fromEntries(
      askedRequests.map((request) => [
        getRatePlanRequestKey(request),
        matchedRatePlanNameByPackageId[request.packageId] ?? null,
      ]),
    ),
  };
}

export function readRatePlanSuggestions(requests: Array<RatePlanMatchRequest>, answers: RatePlanAnswers) {
  return Object.fromEntries(
    requests.flatMap((request) => {
      const ratePlanName = answers[getRatePlanRequestKey(request)];

      return ratePlanName ? [[request.packageId, ratePlanName]] : [];
    }),
  );
}
